module.exports = __webpack_public_path__ + "static/media/Artboard – 3.46a47f36.png";